<!-- Full-width strip under the KPI cards: one tile per service/tenant so the row height stays
     fixed no matter how many targets exist (a tall card inside the KPI grid broke that row). -->
<a routerLink="/platform-health" class="block p-4 panel rounded-2xl hover:shadow-md transition-shadow">
    <div class="flex items-center justify-between pb-2 mb-3 border-b border-gray-200 dark:border-white/10">
        <h5 class="flex items-center gap-2 text-base font-normal text-gray-900 dark:text-white"><icon-heart class="size-5 text-gray-400" />Platform health</h5>
        <span *ngIf="health()?.generated_at" class="text-xs text-gray-400">
            Refreshed {{ health()!.generated_at | date:'HH:mm' }}
        </span>
    </div>

    <p *ngIf="loadError()" class="text-xs text-red-500">{{ loadError() }}</p>
    <p *ngIf="monitoringPaused" class="mb-2 text-xs text-amber-600 dark:text-amber-400">
        Monitoring is off — no live health polling. Open Platform health to turn it on.
    </p>

    <div *ngIf="!monitoringPaused" class="grid gap-3 grid-cols-2 md:grid-cols-3 xl:grid-cols-6">
        <div *ngFor="let target of health()?.services"
            class="rounded-xl border border-gray-100 px-3 py-2 dark:border-white/5">
            <div class="flex items-center gap-2 text-sm">
                <span class="h-2 w-2 shrink-0 rounded-full" [ngClass]="dotClass(target.status)" aria-hidden="true"></span>
                <span class="truncate font-medium text-gray-700 dark:text-gray-200">{{ target.target_key }}</span>
                <span class="ml-auto text-xs text-gray-400">{{ uptimeText('SERVICE', target.target_key) }}</span>
            </div>
            <div class="mt-0.5 truncate text-xs text-gray-400">
                {{ target.version ?? '—' }}&#64;{{ target.git_sha ?? '—' }} · {{ target.latency_ms ?? '—' }}ms
            </div>
            <div *ngIf="failingChecks(target).length" class="truncate text-xs text-red-500">
                failing: {{ failingChecks(target).join(', ') }}
            </div>
        </div>

        <!-- One tile for all tenants: counts, plus the few that need attention. The full list is on the page. -->
        <div *ngIf="tenantTotal" class="rounded-xl border border-gray-100 px-3 py-2 dark:border-white/5">
            <div class="flex items-center gap-2 text-sm">
                <span class="h-2 w-2 shrink-0 rounded-full" [ngClass]="dotClass(tenantSummaryStatus)" aria-hidden="true"></span>
                <span class="truncate font-medium text-gray-700 dark:text-gray-200">Tenants</span>
                <span class="ml-auto text-xs text-gray-400">{{ tenantsOk }}/{{ tenantTotal }} ok</span>
            </div>
            <div *ngIf="!unhealthyTenants.length" class="mt-0.5 text-xs text-gray-400">all healthy</div>
            <div *ngFor="let t of unhealthyTenants.slice(0, maxNamedTenants)" class="mt-0.5 truncate text-xs"
                [ngClass]="t.status === 'down' ? 'text-red-500' : 'text-amber-600'">
                {{ t.target_key }} · {{ t.status }}<ng-container *ngIf="failingChecks(t).length"> · {{ failingChecks(t).join(', ') }}</ng-container>
            </div>
            <div *ngIf="unhealthyTenants.length > maxNamedTenants" class="mt-0.5 text-xs text-gray-400">
                +{{ unhealthyTenants.length - maxNamedTenants }} more
            </div>
        </div>
    </div>
</a>
